// extracted by mini-css-extract-plugin
module.exports = {"icon":"SelectIcon_icon__1jLPP","radio":"SelectIcon_radio__qizAZ","selected":"SelectIcon_selected__2hXZH","checkbox":"SelectIcon_checkbox__na5Cn"};